/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerplacementbottomright3Inputs */

const en_flyerplacementbottomright3 = /** @type {(inputs: Flyerplacementbottomright3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bottom right`)
};

const de_flyerplacementbottomright3 = /** @type {(inputs: Flyerplacementbottomright3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unten rechts`)
};

/**
* | output |
* | --- |
* | "Bottom right" |
*
* @param {Flyerplacementbottomright3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerplacementbottomright3 = /** @type {((inputs?: Flyerplacementbottomright3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerplacementbottomright3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerplacementbottomright3(inputs)
	return de_flyerplacementbottomright3(inputs)
});
export { flyerplacementbottomright3 as "flyerPlacementBottomRight" }